/* Atipiná PDP — galeria collapsed DESATIVADA (Alex, 2026-07-27).
   Antes: desktop mostrava 2 fotos + botão MOSTRAR MAIS/MENOS.
   Agora: todas as fotos ficam visíveis em rolagem vertical (estilo Zara/Prada),
   então este script vira no-op de propósito. O arquivo continua referenciado
   no theme.liquid, por isso não foi deletado. */
(function(){ 'use strict'; })();
